import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import useLoginAndSaveSearch from '~/hooks/useLoginAndSaveSearch';
import {
  Heading,
  LowResultWrapper,
  SaveSearchButton,
  Subtitle
} from './SimilarResults/SimilarResultSection.styles';
import SimilarResultsSection from './SimilarResults/SimilarResultsSection';

const LowResultSection = () => {
  const handleSaveSearch = useLoginAndSaveSearch();
  const trackEvent = useTrackEvent();

  useEffect(() => {
    trackEvent('Low Results Shown');

    datadogRum.addAction('Low Results Shown');
  }, [trackEvent]);

  return (
    <>
      <LowResultWrapper>
        <Heading role="heading">We didn’t find many matches</Heading>
        <Subtitle className="subtitle">
          We get more cars every day. Get vehicles you’re looking for, straight
          to your inbox!
        </Subtitle>
        <SaveSearchButton
          className="save-search-button"
          data-analytics-id="create-search-alert-lrp"
          type="button"
          onClick={handleSaveSearch}
        >
          Save This Search
        </SaveSearchButton>
      </LowResultWrapper>
      <SimilarResultsSection />
    </>
  );
};

export default LowResultSection;
